import {
    REQUEST_APP_CONTACTS,
    RESPONSE_APP_CONTACTS,
    FAILURE_APP_CONTACTS,
  } from "../../../actions/types";
  
  const stateFilters = {
    name: "",
    email: "",
    totalEvents: 0,
    totalConnection: 0,
    added_by: "",
    size: 25,
    from: 0,
    activePage: 1,
    sort: { key: "name", order: "desc" }
  }
  
  const initialState = {
    isFetching: false,
    error: false,
    filters: { ...stateFilters },
    isMyContacts: false,
    searchInput: ""
  };
  
  const setFetching = (state, action) => {
    let { filters = { ...stateFilters }, isMyContacts = false, searchInput } = action.payload;
    return {
      ...state,
      isFetching: true,
      contacts: {},
      filters,
      isMyContacts,
      searchInput
    };
  };
  
  const setFailure = (state, action) => {
    return {
      ...state,
      isFetching: false,
      error: true,
    };
  };
  
  const setcontacts = (state, action) => {
    let results = action.payload.results || [];
    let total = action.payload.total;
    let contacts = {};
    results.forEach((l) => {
      contacts[l._id] = l;
    });
    return {
      ...state,
      isFetching: false,
      error: false,
      total,
      contacts,
    };
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_APP_CONTACTS:
        return setFetching(state, action);
        break;
  
      case RESPONSE_APP_CONTACTS:
        return setcontacts(state, action);
  
      case FAILURE_APP_CONTACTS:
        return setFailure(state, action);
  
      default:
        return state;
        break;
    }
  };
  
